import {
    GET_MERCHANT_INVOICE_LOADING,
    GET_MERCHANT_INVOICE_SUCCESS,
    GET_MERCHANT_INVOICE_FAILED,
    REMOVE_MERCHANT_INVOICE
} from "../types";

const initialState = {
    loading: false,
    error: null,
    InvoiceDetails: null,
};

export const merchantInvoiceReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_INVOICE_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                InvoiceDetails: action.payload,
                error: null,
            };
        case GET_MERCHANT_INVOICE_FAILED:
            return {
                ...state,
                loading: false,
                InvoiceDetails: null,
                error: action.error,
            };
        case REMOVE_MERCHANT_INVOICE:
            return initialState;
        default:
            return state;
    }
};
